module.exports = __webpack_public_path__ + "static/16invgde-ab5dfa1a6c5be37c5413b825f77802aa.gif";